import { RootState } from '~/reducers';

export const getVendorCreditAccountDetails = (state: RootState) =>
  state.vendors.creditAccountDetails.byStorefrontUuid;

export const getVendorCreditAccountDetailsBusy = (state: RootState) =>
  state.vendors.creditAccountDetails.busy;
